import { BrowseLevelsAllPage } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels.all";

export default function BrowseLevelsIndexRoute() {
  return <BrowseLevelsAllPage />;
}
